// Single source of truth for blog author info.
export const TEAM_AUTHOR = {
  id: 'team',
  name: 'The Everything PDF Team',
  role: 'Field notes from reviewing thousands of real PDFs',
  initials: 'EP',
};
